import './App.css';
import './MediaQueries.css';
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import { useEffect, useRef } from "react";
import sendMetaEvent from "./Utils/metaTracking";
import ScrollToTop from './Components/ScrollToTop';
import Header from './Components/Header';
import Footer from './Components/Footer';

import Home from './Pages/Home';
import About from './Pages/About';
import PrakrutiAnalysis from './Pages/PrakrutiAnalysis';
import Contact from './Pages/Contact';
import BookAppointment from './Pages/BookAppointment';
import ErrorPage from './Pages/ErrorPage';
import Blog from './Pages/Blog';
import BlogDetail from './Pages/BlogDetail';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsConditions from './Pages/TermsConditions';
import Treatments from './Pages/Treatments';
import Testimonials from './Pages/Testimonials';
import Sitemap from './Pages/Sitemap';
import TreatmentsCommon from './Pages/TreatmentsCommon';
import TreatmentsCommonGandhidham from './Pages/TreatmentsCommonGandhidham';
import TreatmentsDetailGandhidham from './Pages/TreatmentsDetailGandhidham';
import ThankYou from './Pages/ThankYou';

function AppContent() {
  const location = useLocation();

  const lastTrackedPage = useRef('');

useEffect(() => {
  const currentPage = location.pathname + location.search;

  // Avoid duplicate tracking of the same route.
  if (lastTrackedPage.current === currentPage) {
    return;
  }

  lastTrackedPage.current = currentPage;

  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView');
  }
}, [location.pathname, location.search]);

useEffect(() => {
  const handleWhatsAppClick = () => {
    sendMetaEvent("WhatsAppClick");
  };

  window.addEventListener(
    "whatsapp-widget-click",
    handleWhatsAppClick
  );

  return () => {
    window.removeEventListener(
      "whatsapp-widget-click",
      handleWhatsAppClick
    );
  };
}, []);

  return (
    <>
      <ScrollToTop />

      {/* Header remounts on every route change */}
      <Header key={location.pathname} />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route
          path="/prakruti-analysis"
          element={<PrakrutiAnalysis />}
        />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/treatments" element={<TreatmentsCommon />} />
        <Route
          path="/treatments/:slug"
          element={<Treatments />}
        />
        <Route
          path="/testimonials"
          element={<Testimonials />}
        />
        <Route path="/contact-us" element={<Contact />} />
        <Route
          path="/book-appointment"
          element={<BookAppointment />}
        />
        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy />}
        />
        <Route
          path="/terms-and-conditions"
          element={<TermsConditions />}
        />
        <Route
          path="/sitemap"
          element={<Sitemap />}
        />
        <Route path="/*" element={<ErrorPage />} />

        <Route path="/treatments/gandhidham" element={<TreatmentsCommonGandhidham />} />

        <Route path="/treatments/gandhidham/:slug" element={<TreatmentsDetailGandhidham />} />
        <Route path="/thank-you" element={<ThankYou />} />

      </Routes>

      <Footer />
            
    </>
/** schema,blog*/
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;